import {
  ButtonGroup,
  SelectOption,
  StyledText,
} from '@leasequery/lq.react-component-library';
import React, { useCallback } from 'react';
import { useAuth } from '../../../context';
import * as Styled from '../styled';

interface ViewClientsProps {
  filterStatus: boolean;
  updateFilterStatus: (status: boolean) => void;
}

const BUTTON_GROUP_OPTIONS: SelectOption<boolean>[] = [
  { key: 0, label: 'Yes', value: true },
  { key: 1, label: 'No', value: false },
];

export const ViewAllClients = ({
  filterStatus,
  updateFilterStatus,
}: ViewClientsProps): JSX.Element => {
  const { client } = useAuth();

  const buttonToggleHandler = useCallback((): void => {
    updateFilterStatus(!filterStatus);
  }, [filterStatus, updateFilterStatus]);

  return (
    <Styled.ViewAllClients>
      <div className="text">
        Show results for{' '}
        <StyledText fontWeight="bold">{client.companyName}</StyledText> only
      </div>
      <ButtonGroup
        options={BUTTON_GROUP_OPTIONS}
        selectedOption={BUTTON_GROUP_OPTIONS[filterStatus ? 0 : 1]}
        onClick={buttonToggleHandler}
        name="displayCurrentClient"
      />
    </Styled.ViewAllClients>
  );
};
